<template>
    <div>
        <TableList
            :form_data_seo.sync="form_data_seo"
            :columns="columns"
            :get_table_list="this.get_table_list"
            :slot_table_list="[]"
            ref="list"
            :submit_preprocessing="submit_preprocessing"
        >
        </TableList>

    </div>
</template>

<script>

import TableList from "@/components/TableList";
import { getLoginRecord } from "@/api/locus";
                                                                                                                                                                                                                             
const columns = [
   {
   		title: "司机名称",
   		dataIndex: "name",
   	},
   
   	{
   		title: "联系电话",
   		dataIndex: "phone",
   	},
    {
        title: "IP地址",
     dataIndex: "ip",
    },
    
    {
        title: "登录时间",
        dataIndex: "create_time",
    },
];

export default {
    name: "Index",
    components: {
		TableList,
    },
    data() {
        return {
            get_table_list: getLoginRecord,
            submit_preprocessing: {
                array_to_string: ['department']
            },
            order_details: {
                goods: [],
            },
            columns,
            form_data_seo: {
                list: [
					
                    {
                        type: "text",
                        name: "keyword",
                        title: "司机信息",
                        placeholder: '请输入司机姓名/电话',
                        mode: "default",
                        options: {},
                        list: []
					},
					
                ],
                ...this.$config.form_data_seo
            },
            form_data: {}
        };
    },
    async created() {
       
    },
    methods: {

    }
};
</script>

<style lang="less">

</style>